export default "__VITE_ASSET__JhyIIVgr__"